import { render } from "./FeedbackView.vue?vue&type=template&id=fbaad69a"
import script from "./FeedbackView.vue?vue&type=script&lang=js"
export * from "./FeedbackView.vue?vue&type=script&lang=js"

import "./FeedbackView.vue?vue&type=style&index=0&id=fbaad69a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__